import React from "react";
import { Typography } from "antd";
import { FormattedMessage } from "react-intl";
const { Text } = Typography;

const ContractDayType = (props) => {
  const { text } = props;
  const contractDayTypeData = [
    { value: 1, name: <FormattedMessage id="app.forms.weekDay" /> },
    { value: 2, name: <FormattedMessage id="app.forms.holiday" /> },
    { value: 3, name: <FormattedMessage id="app.forms.holidayNight" /> },
  ];
  const filtered = contractDayTypeData.filter((i) => i.value === text)[0];

  return <Text>{filtered && filtered.name}</Text>;
};

export default ContractDayType;
